import { render } from "./OfferRewardsEdit.vue?vue&type=template&id=2293d9b3"
import script from "./OfferRewardsEdit.vue?vue&type=script&lang=js"
export * from "./OfferRewardsEdit.vue?vue&type=script&lang=js"

import "./OfferRewardsEdit.vue?vue&type=style&index=0&id=2293d9b3&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__